/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewEnumerationRecord } from './CRSFSecReviewEnumerationRecord';
import {
    CRSFSecReviewEnumerationRecordFromJSON,
    CRSFSecReviewEnumerationRecordFromJSONTyped,
    CRSFSecReviewEnumerationRecordToJSON,
} from './CRSFSecReviewEnumerationRecord';

/**
 * 
 * @export
 * @interface CRSFSecReviewEnumerationEvent
 */
export interface CRSFSecReviewEnumerationEvent {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewEnumerationEvent
     */
    fqdn: string;
    /**
     * 
     * @type {Array<CRSFSecReviewEnumerationRecord>}
     * @memberof CRSFSecReviewEnumerationEvent
     */
    records: Array<CRSFSecReviewEnumerationRecord>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewEnumerationEvent
     */
    sources?: Array<string>;
}

/**
 * Check if a given object implements the CRSFSecReviewEnumerationEvent interface.
 */
export function instanceOfCRSFSecReviewEnumerationEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fqdn" in value;
    isInstance = isInstance && "records" in value;

    return isInstance;
}

export function CRSFSecReviewEnumerationEventFromJSON(json: any): CRSFSecReviewEnumerationEvent {
    return CRSFSecReviewEnumerationEventFromJSONTyped(json, false);
}

export function CRSFSecReviewEnumerationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewEnumerationEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fqdn': json['fqdn'],
        'records': ((json['records'] as Array<any>).map(CRSFSecReviewEnumerationRecordFromJSON)),
        'sources': !exists(json, 'sources') ? undefined : json['sources'],
    };
}

export function CRSFSecReviewEnumerationEventToJSON(value?: CRSFSecReviewEnumerationEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fqdn': value.fqdn,
        'records': ((value.records as Array<any>).map(CRSFSecReviewEnumerationRecordToJSON)),
        'sources': value.sources,
    };
}

